'use client';

import { PageHeader } from '@eliadmin/core/src/components/homepage/page-header';
import { JobPortalFilterParamsSync } from '@eliadmin/core/src/components/jobportal/homepage/jobportal-set-filter';
import { JobOffersFilterLeft } from '@eliadmin/core/src/components/jobportal/job-offers/job-offers-filter-left';
import { JobportalOffersHeader } from '@eliadmin/core/src/components/jobportal/job-offers/jobportal-offers-header';
import { JobPortalOffersContainer } from '@eliadmin/core/src/components/jobportal/jobportal-offers-container';
import { Container } from '@eliadmin/core/src/components/ui/container';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import type { EliPageProps } from '@eliadmin/core/src/i18n/i18n-types';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import {
  JobportalOffersFilterParamsSync,
  JobportalOffersStoreProvider,
} from '@eliadmin/core/src/stores/jobportal-offers-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { normalizeJobOfferSort } from '@eliadmin/core/src/utils/retired-list-sort';
import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';

export default function JobPortalOffersPage(props: EliPageProps) {
  const searchParams = useSearchParams();
  const { t } = useTranslations();
  const generalLayout = useGlobalStore(s => s.generalLayout);

  const search = searchParams.get('search') || undefined;
  const minSalary = searchParams.get('min_salary') || undefined;
  const maxSalary = searchParams.get('max_salary') || undefined;
  const categories = searchParams.get('categories') || undefined;
  const employmentTypes = searchParams.get('employment_types') || undefined;
  const salaryTypes = searchParams.get('salary_types') || undefined;
  const workingHours = searchParams.get('working_hours') || undefined;
  const drivingLicenses = searchParams.get('driving_licenses') || undefined;
  const language = searchParams.get('language') || undefined;
  const city = searchParams.get('city') || undefined;
  const distance = searchParams.get('distance') || undefined;
  const { order, orderBy } = normalizeJobOfferSort({
    order: searchParams.get('order') || undefined,
    orderBy: searchParams.get('orderBy') || undefined,
  });
  const selectedOffer = searchParams.get('selectedOffer') || undefined;
  const dualEducation = searchParams.get('dual_education') || undefined;

  return (
    <>
      <PageHeader
        breadcrumb={{
          name: t('text788'),
          slug: ROUTES.JOB_OFFERS(),
        }}
      />
      <JobportalOffersStoreProvider
        state={{
          filter: {
            search,
            selectedOffer,
            min_salary: minSalary ? minSalary : undefined,
            max_salary: maxSalary ? maxSalary : undefined,
            categories: categories?.length ? categories.split(',') : [],
            employment_types: employmentTypes?.length ? employmentTypes.split(',') : [],
            salary_types: salaryTypes?.length ? salaryTypes.split(',') : [],
            working_hours: workingHours?.length ? workingHours.split(',') : [],
            driving_licenses: drivingLicenses?.length ? drivingLicenses.split(',') : [],
            language: language?.length ? language.split(',') : [],
            city: city?.length ? city.split(',') : [],
            distance: distance?.length ? distance.split(',') : [],
            order: (order as any) || 'desc',
            orderBy: (orderBy as any) || 'published_at',
            dual_education: dualEducation === 'true' ? true : false,
          },
        }}
      >
        <JobportalOffersFilterParamsSync />
        <Container
          className={cn('flex flex-col gap-8 px-0 py-8 md:px-4', 'ea-job-portal-offers__container')}
        >
          {/* <JobPortalOffersFilter /> */}
          <div className={cn('grid w-full grid-cols-12 gap-8', 'ea-job-portal-offers__grid')}>
            <div
              className={cn(
                'col-span-12 md:col-span-5 lg:col-span-3',
                'ea-job-portal-offers__filter',
              )}
            >
              <div className="hidden md:block">
                <JobOffersFilterLeft />
              </div>
            </div>
            <div className={cn('col-span-12 md:col-span-7 lg:col-span-9', 'ea-job-portal-offers')}>
              <JobportalOffersHeader />
              <Suspense fallback={<div />}>
                <JobPortalOffersContainer />
              </Suspense>
            </div>
          </div>
        </Container>
      </JobportalOffersStoreProvider>
    </>
  );
}
